"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSignatureText = exports.stripLabelNumericSuffixFromSelector = void 0;
const selector_1 = require("./selector");
const textNorm_1 = require("./textNorm");
// Only strips underscore-digit chains: `poi_hot_city_0_0` -> `poi_hot_city`,
// `tab_1` -> `tab`. Values without an underscore-digit suffix are returned
// unchanged: `address2` -> `address2`.
const NUMERIC_SUFFIX_RE = /(_\d+)+$/;
const DESC_LABEL_TOKEN_RE = /\[(desc|label)='((?:\\.|[^'\\])*)'\]/g;
/**
 * Strips a trailing numeric suffix from the `desc`/`label` values inside a
 * rendered selector, so `[label='tab_1']` and `[label='tab_2']` collapse onto
 * one identity. className, role, res and id are left alone.
 */
const stripLabelNumericSuffixFromSelector = (selectorText) => selectorText.replace(DESC_LABEL_TOKEN_RE, (_match, attr, val) => {
    const stripped = val.replace(NUMERIC_SUFFIX_RE, '');
    return `[${attr}='${stripped}']`;
});
exports.stripLabelNumericSuffixFromSelector = stripLabelNumericSuffixFromSelector;
/**
 * The final element signature for one violation. `ancestry` arrives root-first
 * and is rendered leaf-first.
 *
 * `element` must ALREADY have been through
 * `stripLabelNumericSuffixFromSelector`; this function applies it to the
 * ancestry text only.
 */
const buildSignatureText = ({ element, siblings, ancestry, children }) => {
    if (!element || element === 'unknown') {
        return '';
    }
    const lines = [`Element: ${element}`];
    if (siblings && siblings !== textNorm_1.EMPTY_MARKER) {
        lines.push(`Siblings: ${siblings}`);
    }
    if (ancestry.length > 0) {
        const path = [...ancestry].reverse();
        const text = (0, exports.stripLabelNumericSuffixFromSelector)((0, selector_1.formatAncestryPath)(path));
        lines.push(`Ancestry: ${text}`);
    }
    if (children && children !== textNorm_1.EMPTY_MARKER) {
        lines.push(`Children: ${children}`);
    }
    return lines.join('\n');
};
exports.buildSignatureText = buildSignatureText;
//# sourceMappingURL=signature.js.map